/**
 * 2019/1/15
 * 作者:lzq
 *功能: 功能管理模块
 */
export default {
  $getway: 'sysapi',
  getFunctionList: 'function/list',
  saveFunction: 'function/save',
  getFunctionDetail: 'function/detail',
  updateFunctionStatus: 'function/open',
  getAllFunctionList: 'function/selectAllFunctionName'
};
